import { MailIcon } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

type Props = {
  vendorName: string;
};

export const FulfillingRequestBanner = ({ vendorName }: Props) => (
  <Alert className="grid-cols-[auto_1fr] items-start gap-x-4 rounded-xl border-sky-200 bg-sky-100 p-4">
    <span className="flex size-6.5 shrink-0 items-center justify-center rounded-full bg-sky-500">
      <MailIcon className="size-3.5 text-white" />
    </span>
    <div className="col-start-2">
      <AlertTitle className="text-sm font-extrabold">You&apos;re fulfilling a request from {vendorName}</AlertTitle>
      <AlertDescription>
        When you add this application, we&apos;ll list them as a beneficiary and email them that you&apos;ve accepted
        their request. You can both set up protection for it from there.
      </AlertDescription>
    </div>
  </Alert>
);
